// Inscripción de consultAR en el ReNaPDiS (Registro Nacional de Plataformas
// Digitales Sanitarias) del Ministerio de Salud de la Nación: Recetario N° 269,
// estándar HL7 FHIR. Un solo lugar para el número y el enlace al listado
// oficial (lo usan la home, el pie y, en texto fijo, public/index.html).
export const NUMERO_RENAPDIS = 269;
export const URL_RENAPDIS =
  'https://www.argentina.gob.ar/salud/digital/renapdis/plataformas-aprobadas-por-el-ministerio-de-salud-de-la-nacion';
